/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventFreeNftUpdateRequest model module.
 * @module model/EventsControllerDtoEventFreeNftUpdateRequest
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftUpdateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftUpdateRequest</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftUpdateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventFreeNftUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftUpdateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftUpdateRequest} The populated <code>EventsControllerDtoEventFreeNftUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftUpdateRequest();

            if (data.hasOwnProperty('freenftNo')) {
                obj['freenftNo'] = ApiClient.convertToType(data['freenftNo'], 'Number');
            }
            if (data.hasOwnProperty('mintingCode')) {
                obj['mintingCode'] = ApiClient.convertToType(data['mintingCode'], 'String');
            }
            if (data.hasOwnProperty('issuedCount')) {
                obj['issuedCount'] = ApiClient.convertToType(data['issuedCount'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['mintingCode'] && !(typeof data['mintingCode'] === 'string' || data['mintingCode'] instanceof String)) {
            throw new Error("Expected the field `mintingCode` to be a primitive type in the JSON string but got " + data['mintingCode']);
        }

        return true;
    }


}



/**
 * @member {Number} freenftNo
 */
EventsControllerDtoEventFreeNftUpdateRequest.prototype['freenftNo'] = undefined;

/**
 * @member {String} mintingCode
 */
EventsControllerDtoEventFreeNftUpdateRequest.prototype['mintingCode'] = undefined;

/**
 * @member {Number} issuedCount
 */
EventsControllerDtoEventFreeNftUpdateRequest.prototype['issuedCount'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventFreeNftUpdateRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventFreeNftUpdateRequest.prototype['endAt'] = undefined;






export default EventsControllerDtoEventFreeNftUpdateRequest;

